import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import { ChartDataset, TooltipCallbacks } from 'chart.js';
import { _DeepPartialObject } from 'chart.js/dist/types/utils';
import { AnleggAar } from 'src/app/services/forbruk/forbruk.types';
import {
  labelTooltipCallback,
  titleTooltipCallback
} from '../../../../forbruk/charts/forbruk-charts-utils';
import { hasChanged } from 'src/app/utils/change-utils';

@Component({
  selector: 'app-year-chart-price',
  templateUrl: './year-chart-price.component.html',
  styleUrls: ['./year-chart-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class YearChartPriceComponent implements OnInit, OnChanges {
  @Input() selectedDate: Date;
  @Input() valgtAnlegg: AnleggAar;

  useCurrentYear: boolean;
  usePreviousYear: boolean;
  dataSets: ChartDataset<'bar'>[];
  labels: string[];
  title: string;
  displayLegend = true;
  tooltipCallbacks: _DeepPartialObject<TooltipCallbacks<'bar'>>;

  constructor() {}

  ngOnInit(): void {
    if (this.valgtAnlegg && this.selectedDate) {
      this.getChartData();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.valgtAnlegg &&
      this.selectedDate &&
      hasChanged([changes?.valgtAnlegg, changes?.selectedDate])
    ) {
      this.getChartData();
    }
  }

  getChartData() {
    this.dataSets = [];

    // Plusskunde produksjon
    const belopPluss = [];
    let plusskundedataFound = false;

    this.title = 'Kostnad';
    this.tooltipCallbacks = {
      label: (tt) => labelTooltipCallback(tt, 'kr'),
      title: (tt) =>
        titleTooltipCallback(tt, 'year', 'kr', 'forbruk_tooltip_chart2')
    };

    const data = this.valgtAnlegg.aarVerdiList.map((verdi) => {
      if (this.valgtAnlegg.plusskunde) {
        const plussEarned = verdi.belopPlussverdi
          ? Math.abs(verdi.belopPlussverdi)
          : 0;

        if (plussEarned) {
          plusskundedataFound = true;
          belopPluss.push(plussEarned);
        } else belopPluss.push(0);
      }
      return {
        label: verdi.aar.toString(),
        kraft: verdi.belopKraft || 0,
        nettleie: verdi.belopNettleie || 0,
        belop: verdi.belop || 0
      };
    });

    this.labels = data.map((x) => x?.label);
    this.dataSets.push({
      data: data.map((x) => x?.kraft || 0),
      label: 'Strøm',
      pointStyle: 'circle',
      backgroundColor: '#002987',
      barThickness: this.valgtAnlegg.gjennomfakturering ? 25 : 50,
      borderRadius: [{ topLeft: 10, topRight: 10 }]
    });
    if (this.valgtAnlegg.gjennomfakturering) {
      this.dataSets.push({
        data: data.map((x) => x?.nettleie || 0),
        label: 'Nettleie',
        pointStyle: 'circle',
        backgroundColor: '#ff80ff',
        barThickness: 25,
        borderRadius: [{ topLeft: 10, topRight: 10 }]
      });
    }
    if (plusskundedataFound) {
      this.dataSets.push({
        barThickness: 25,
        borderRadius: [{ topLeft: 10, topRight: 10 }],
        data: belopPluss,
        backgroundColor: '#26b41b',
        label: 'Inntekt Plusskunde'
      });
    }
  }
}
